var card = "https://shopfront-cdn.tekoapis.com/static/abf02ec95226fd05.svg";

export { card as default };
